import { environment } from './../../../../environments/environment'
import { BreadCrumbActions } from 'src/app/shared/components/breadcrumb/breadcrumb.actions'
import { Observable } from 'rxjs'
import { startWith, switchMap } from 'rxjs/operators'
import { AppState } from 'src/app/core/core.state'

import { Component, OnInit } from '@angular/core'
import { Store } from '@ngrx/store'

import { Organization } from '../organization'
import { organizationSelectors } from '../organization.selectors'
@Component({
  selector: 'organization-show',
  templateUrl: './show.component.html',
  styleUrls: ['./show.component.scss']
})
export class OrganizationShowComponent implements OnInit {
  public organization$: Observable<Organization>
  public organizationId$: Observable<number>
  public isLoading$: Observable<boolean>
  public arrayTabMenuObjects: any[] = []
  public moduleConfigs: any = environment.moduleConfigs

  constructor(private store: Store<AppState>) {}

  ngOnInit() {
    this.arrayTabMenuObjects = [
      {
        name: '',
        jsonTranslation: 'general.general',
        show: true,
        iconName: 'cube'
      },
      {
        name: 'bookings-organization',
        jsonTranslation: 'bookingModule.bookingsOrganizations',
        show: environment.moduleConfigs.bookingModule.isActive,
        iconName: 'calendar-alt'
      },
      {
        name: 'user-roles',
        jsonTranslation: 'general.roles',
        show: true,
        iconName: 'users'
      },
      {
        name: 'sales',
        jsonTranslation: 'saleModule.sales',
        show: environment.moduleConfigs.saleModule.isActive,
        iconName: 'shopping-cart'
      },
      {
        name: 'required-subscriptions',
        jsonTranslation: 'subscriptionModule.requiredSubscriptions',
        show: environment.moduleConfigs.subscriptionModule.isActive,
        iconName: 'credit-card'
      },
      {
        name: 'documents',
        jsonTranslation: 'general.documents',
        show: true,
        iconName: 'image'
      },
      {
        name: 'activities',
        jsonTranslation: 'activityModule.activities',
        show: true,
        iconName: 'clipboard-check'
      },
      {
        name: 'addresses',
        jsonTranslation: 'organizationModule.addresses',
        show: true,
        iconName: 'map-marker-alt'
      }
    ]
    this.isLoading$ = this.store
      .select(organizationSelectors.selectIsLoading)
      .pipe(startWith(false))

    this.organizationId$ = this.store.select(
      organizationSelectors.selectIdRouteParam
    )

    this.organization$ = this.organizationId$.pipe(
      switchMap((organizationId) =>
        this.store.select(organizationSelectors.selectById, organizationId)
      )
    )
  }
}
